// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "6edf0643" + "." + "d8a7c6b6bdcdfe66" + ".js";
};